import joi from 'joi';
import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateNotFoundError, generateValidationError, success } from '../../../shared/api.response.def';

const response = joi.string().description('An SVG document containing the rendered annotations for the capture');

export const definition = makeDefinitionFor(
	'/collection.capture.annotations',
	{
		description:
			'Render the annotations of a collection capture as an SVG document. The capture must be calibrated. Identify the collection with exactly one of collectionId and collectionUuid.',
		method: 'get',
		summary: 'Capture annotations SVG',
		tags: ['Collection'],
		params: [
			{
				$ref: '#/components/parameters/ikeDepartmentId',
			},
			{
				$ref: '#/components/parameters/collectionIdQuery',
			},
			{
				$ref: '#/components/parameters/collectionUuidQuery',
			},
			{
				$ref: '#/components/parameters/captureIdQuery',
			},
			{
				$ref: '#/components/parameters/timezoneQuery',
			},
			{
				$ref: '#/components/parameters/unitsQuery',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: response,
			responseType: 'image/svg+xml',
		},
		generateNotFoundError(
			'The collection could not be found, the capture is not part of the collection, or the capture is not calibrated and cannot be rendered.'
		),
		generateValidationError(),
	]
);
